import { screenSizes } from '@shipt/design-system-themes'
import { spacingPx } from '@/features/shared/theme/tokens'
import styled from 'styled-components'

export const GridLayoutContainer = styled.div<{
  contentMaxWidth?: boolean
}>`
  --padding-inline: ${spacingPx('lg')};
  --content-max-width: 1080px;

  // Primary class
  &,
  & > .fullWidth.withContent {
    display: grid;
    grid-template-columns:
      [full-width-start] minmax(calc(var(--padding-inline)), 1fr)
      [content-start] min(
        100% - (var(--padding-inline) * 2),
        var(--content-max-width)
      )
      [content-end] minmax(calc(var(--padding-inline)), 1fr)
      [full-width-end];
  }

  & > .content,
  & > .fullWidth.withContent > *,
  & > *:not(.content, .fullWidth) {
    grid-column: content;
  }

  & > .fullWidth {
    grid-column: full-width;
  }

  // Secondary classes please add in addition to Primary class
  & > .contentAtLgMobile {
    @media ${screenSizes.lgMobile} {
      grid-column: content;
    }
  }

  & > .contentAtTablet {
    @media ${screenSizes.tablet} {
      grid-column: content;
    }
  }

  & > .contentAtSmDesktop {
    @media ${screenSizes.smDesktop} {
      grid-column: content;
    }
  }

  & > .fullWidthAtTablet {
    grid-column: content;
    @media ${screenSizes.tablet} {
      grid-column: full-width;
    }
  }

  @media ${screenSizes.tablet} {
    --padding-inline: ${spacingPx('xxl')};
  }

  @media ${screenSizes.smDesktop} {
    --padding-inline: ${spacingPx('3xl')};
  }

  @media ${screenSizes.tablet} {
    --content-max-width: ${({ contentMaxWidth }) => (contentMaxWidth ? '1400px' : '1080px')};
  }
`
